export const ROLE_LABEL = { operateur: "Opérateur", chef_equipe: "Chef d'équipe", controleur: "Contrôleur", superviseur: "Superviseur", admin: "Administrateur" };
export const roleLabel = (u) => (u?.platform_admin ? "Administrateur plateforme" : ROLE_LABEL[u?.role]);

export const POLICY_LABEL = {
  always: "Toujours",
  anomaly: "En cas d'anomalie",
  user_change_or_anomaly: "Changement d'utilisateur ou anomalie",
};

export const EQUIP_STATUS_OPTIONS = [
  { value: "disponible", label: "Disponible" },
  { value: "bloque", label: "Bloqué" },
  { value: "maintenance", label: "En maintenance" },
  { value: "hors_service", label: "Hors service" },
];

export const TIME_FORMATS = [
  { value: "24h", label: "24 h (ex. 21:30)" },
  { value: "12h", label: "12 h AM/PM (ex. 9:30 PM)" },
];

export const TIMEZONES = [
  "Europe/Paris", "Europe/Brussels", "Europe/Luxembourg", "Europe/Zurich", "Europe/Monaco", "Europe/London",
  "America/Toronto", "America/Montreal", "America/Guadeloupe", "America/Martinique", "America/Cayenne",
  "Indian/Reunion", "Indian/Mayotte", "Pacific/Noumea", "Pacific/Tahiti", "Africa/Casablanca", "Africa/Dakar",
  "Africa/Abidjan", "Africa/Algiers", "Africa/Tunis", "UTC",
].map((v) => ({ value: v, label: v }));

export const RESULT_KEY = (insp) => (insp.status === "brouillon" ? "insp_brouillon" : insp.result);

export const IDENT_KINDS = [
  { value: "interne", label: "Identifiant interne" },
  { value: "immatriculation", label: "Immatriculation" },
  { value: "parc", label: "Numéro de parc" },
  { value: "serie", label: "Numéro de série" },
  { value: "alias", label: "Alias" },
  { value: "autre", label: "Autre" },
];

export const CONTROL_LEVELS = [
  { value: 1, label: "1 — Élimination" },
  { value: 2, label: "2 — Substitution" },
  { value: 3, label: "3 — Protection technique / collective" },
  { value: 4, label: "4 — Organisation / administratif" },
  { value: 5, label: "5 — EPI" },
];

export const levelLabel = (v) => CONTROL_LEVELS.find((l) => l.value === v)?.label || "À classer";

export const identLabel = (i) => (i.kind === "autre" ? i.label : IDENT_KINDS.find((k) => k.value === i.kind)?.label || i.kind);
